import { forwardRef } from 'react';
import { useProducts } from '@activebrands/core-web/contexts/ProductsContext';
import FilterBar from 'components/product-listing/FilterBar';

const CategoryFilterBar = forwardRef(({ ...rest }, ref) => {
    const { products, selectedFacets } = useProducts();
    const totalNumberOfProducts = products.length;

    return (
        <FilterBar
            filterOverlayId="category-facet-groups"
            ref={ref}
            selectedFacets={selectedFacets}
            sortOverlayId="category-sort-options"
            totalNumberOfProducts={totalNumberOfProducts}
            {...rest}
        />
    );
});

CategoryFilterBar.displayName = 'CategoryFilterBar';

export default CategoryFilterBar;
